import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

import {
  PublicCartDiscount,
  PublicCartItem,
  PublicCartRecursive,
} from '@web/shared/module/shop';
import {
  CurrencyComponent,
  Icon,
  PrimengDividerDirective,
} from '@web/shared/ui';
import { Divider } from 'primeng/divider';
import { PublicOrderCheckoutItemComponent } from '../public-order-checkout-item/public-order-checkout-item.component';
import { PublicOrderCheckoutDiscountCodeComponent } from '../public-order-checkout-discount-code/public-order-checkout-discount-code.component';
import { isNotNil, Nillable } from '@web/utils';
import { PublicDiscountCodeSubmitEvent } from '../../events/public-discount-code-submit.event';
import { PublicOrderSummaryRecursiveInfoComponent } from '../public-order-summary-recursive-info/public-order-summary-recursive-info.component';
import { PublicOrderSummaryAdditionalShippingCostInfoComponent } from '../public-order-summary-additional-shipping-cost-info/public-order-summary-additional-shipping-cost-info.component';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';

@Component({
  selector: 'app-public-order-checkout-summary',
  imports: [
    Divider,
    PrimengDividerDirective,
    PublicOrderCheckoutItemComponent,
    PublicOrderCheckoutDiscountCodeComponent,
    CurrencyComponent,
    PublicOrderSummaryRecursiveInfoComponent,
    PublicOrderSummaryAdditionalShippingCostInfoComponent,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './public-order-checkout-summary.component.html',
  styleUrl: './public-order-checkout-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderCheckoutSummaryComponent {
  public readonly items = input<PublicCartItem[]>();
  public readonly deliveryCosts = input.required<number>();
  public readonly deliveryQuantity = input.required<number>();
  public readonly deliveryUnitPrice = input.required<number>();
  public readonly totalCosts = input.required<number>();
  public readonly discount = input<Nillable<PublicCartDiscount>>();
  public readonly cartTotalCosts = input.required<number>();
  public readonly recursive = input<PublicCartRecursive[]>([]);
  public readonly shippingMethod = input<Nillable<string>>();
  public readonly shippingMethodDescription = input<Nillable<string>>();

  /* prettier-ignore */
  public readonly discountCodeSubmitEvent = output<PublicDiscountCodeSubmitEvent>();
  protected readonly Icon = Icon;
  protected readonly isNotNil = isNotNil;

  public handleDiscountCodeSubmitEvent(discountCode: Nillable<string>): void {
    this.discountCodeSubmitEvent.emit(
      new PublicDiscountCodeSubmitEvent({ discountCode }),
    );
  }
}
